import React, { useEffect, useRef, useState } from 'react';
import { Star, Quote, CheckCircle, ThumbsUp, Users, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react';

const Testimonials = () => {
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      username: '@beatrizcarolyne10',
      text: 'Já fiz uma viagem com eles... Tudo certinho... Fiquei com medo no começo por não conhecer, mas fui e foi tudo como combinado. Eu e minha família aproveitamos bastante... E já queremos ir de novo 😂'
    },
    {
      username: '@allex.silva.967422',
      text: 'Indico e recomendo, eles têm idoneidade, responsabilidade e confiabilidade. Acompanho a empresa desde o início e super recomendo.'
    },
    {
      username: '@nilma.silva.334',
      text: 'Viajo com Ar turismo há 6 anos só tenho que agradecer. Equipe super atenciosos, muito responsáveis. Iremos viajar novamente este ano. Super recomendo. 👏👏'
    },
    {
      username: '@fofaotricol8',
      text: 'Eu já viajei já são 8 vezes e sempre compraram tudo que foi prometido, e pessoas responsável, educado, dão atenção a viagem toda ide e volta..... Irei novamente ano que vem fé em Deus... AR TURISMO..'
    },
    {
      username: '@karolzitha20',
      text: 'Minha 1ª vez com AR turismo, muito gratificante e realizada. Super indico para qualquer um que deseja realizar seu sonho para ver o mar ou outra maravilha desse mundo. Super indico o trabalho de vcs 😍'
    },
    {
      username: '@devanirmartinsferreira',
      text: 'Uma equipe maravilhosa, muito organizada sempre atento aos passageiros, ônibus muito limpo e os destinos das viagens são um sonho tive o prazer de viajar quatro vezes com eles, super recomendo.'
    },
    {
      username: '@silvanagarocha',
      text: 'Viajei três vezes, e pretendo ir novamente. Agência super responsável e equipe maravilhosa 😍'
    },
    {
      username: '@mendoncarosineide',
      text: 'Já viajei com minha família, super indico, recomendo, equipe excelente, pessoal maravilhoso 😍 são incríveis'
    },
    {
      username: '@angelagoesdossantos',
      text: 'Estou só escolhendo um dos lugares que a agência faz roteiro pra comprar minha viagem do próximo ano 😍'
    },
    {
      username: '@verapitombeira',
      text: 'AGRADEÇO PELO CARINHO DE TODOS VOCÊS. FOI MARAVILHOSO ESTA SEMANA COM VOCÊS. Anderson Raquel Sao muito prestativos Parabéns. 👏👏❤️❤️👏👏😍'
    }
  ];

  // Auto-advance every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  // Scroll to current testimonial
  useEffect(() => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.children[0]?.offsetWidth || 300;
      const gap = 16;
      scrollRef.current.scrollTo({
        left: currentIndex * (cardWidth + gap),
        behavior: 'smooth'
      });
    }
  }, [currentIndex]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-8 md:py-12 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-4 md:mb-6">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-3">
            O que nossos <span className="text-red-600">clientes</span> dizem
          </h2>
        </div>

        {/* Authority Metrics Pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-6">
          <div className="flex items-center gap-1 bg-yellow-50 border border-yellow-200 px-2 py-1 md:px-3 md:py-2 rounded-full">
            <Star className="w-3 h-3 md:w-4 md:h-4 fill-yellow-400 text-yellow-400" />
            <span className="text-xs md:text-sm font-bold text-gray-900">4.9</span>
            <span className="text-[10px] md:text-xs text-gray-500">Google</span>
          </div>
          <div className="flex items-center gap-1 bg-green-50 border border-green-200 px-2 py-1 md:px-3 md:py-2 rounded-full">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-green-600" />
            <span className="text-xs md:text-sm font-bold text-gray-900">Verificada</span>
          </div>
          <div className="flex items-center gap-1 bg-blue-50 border border-blue-200 px-2 py-1 md:px-3 md:py-2 rounded-full">
            <ThumbsUp className="w-3 h-3 md:w-4 md:h-4 text-blue-600" />
            <span className="text-xs md:text-sm font-bold text-gray-900">98%</span>
            <span className="text-[10px] md:text-xs text-gray-500">recomendam</span>
          </div>
          <div className="flex items-center gap-1 bg-purple-50 border border-purple-200 px-2 py-1 md:px-3 md:py-2 rounded-full">
            <Users className="w-3 h-3 md:w-4 md:h-4 text-purple-600" />
            <span className="text-xs md:text-sm font-bold text-gray-900">352</span>
            <span className="text-[10px] md:text-xs text-gray-500">avaliações</span>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          {/* Navigation Arrows - Desktop */}
          <button 
            onClick={goToPrev}
            className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-lg items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <ChevronLeft className="w-6 h-6 text-gray-600" />
          </button>
          <button 
            onClick={goToNext}
            className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-lg items-center justify-center hover:bg-gray-50 transition-colors"
          >
            <ChevronRight className="w-6 h-6 text-gray-600" />
          </button>

          {/* Cards Container */}
          <div 
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`flex-shrink-0 w-[85vw] md:w-[400px] bg-white rounded-xl shadow-lg p-4 md:p-6 border border-gray-100 snap-center transition-all duration-300 ${
                  index === currentIndex ? 'scale-100 opacity-100' : 'scale-95 opacity-70'
                }`}
              >
                {/* Stars */}
                <div className="flex gap-0.5 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Quote */}
                <div className="flex gap-2 mb-4">
                  <Quote className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" />
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                    {testimonial.text}
                  </p>
                </div>

                {/* Username */}
                <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
                  <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-orange-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-bold">
                      {testimonial.username.charAt(1).toUpperCase()}
                    </span>
                  </div>
                  <span className="text-sm font-medium text-gray-600">{testimonial.username}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center items-center gap-2 mt-4">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentIndex ? 'bg-red-500 w-6' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>

        {/* Swipe Indicator */}
        <div className="flex items-center justify-center gap-2 mt-3 text-gray-500">
          <ChevronLeft className="w-4 h-4" />
          <span className="text-xs md:text-sm">Deslize para ver mais avaliações</span>
          <ChevronRight className="w-4 h-4" />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
